const modifyTextWithLink = (text: string, className: string): string => {
  const urlRegex =
    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;

  return text.replace(urlRegex, function (url: string): string {
    return `<a class="${className}" href="${url}" target="_blank">${url}</a>`;
  });
};

export default modifyTextWithLink;
